import { AlertColor } from '@mui/material'
import { create } from 'zustand'

type Snackbar = {
  open: boolean
  message: string
  type: AlertColor
  showCloseIcon: boolean
}

interface SnackbarState {
  snackbar: Snackbar
  openSnackbar: (
    message: Snackbar['message'],
    type: Snackbar['type'],
    showCloseIcon?: Snackbar['showCloseIcon'],
    time?: number,
  ) => void
  closeSnackbar: () => void
}

const useSnackbarStore = create<SnackbarState>((set) => ({
  snackbar: { open: false, message: '', type: 'info', showCloseIcon: true },
  openSnackbar: (message: Snackbar['message'], type: Snackbar['type'], showCloseIcon = true, timeInMs = 5000) => {
    set(() => ({ snackbar: { open: true, message, type, showCloseIcon } }))
    setTimeout(() => {
      set((state) => ({ snackbar: { ...state.snackbar, open: false } }))
    }, timeInMs)
  },
  closeSnackbar: () => set((state) => ({ snackbar: { ...state.snackbar, open: false } })),
}))

export default useSnackbarStore
